import { render, staticRenderFns } from "./SrDataPlaceholder.vue?vue&type=template&id=7f159948"
import script from "./SrDataPlaceholder.vue?vue&type=script&lang=js"
export * from "./SrDataPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports